"use client";


import { useRouter } from "next/navigation";
import { useEffect } from "react";
import type { Product, Variant } from "types/product";
import useEvents from "@app/_hooks/useEvents";

type Props = {
  product: Product;
  variant: Variant | undefined;
  currency: string;
};

export default function Seo(props: Props) {
  const { viewItem } = useEvents();
  const router = useRouter();
  const { variant, product } = props;

  useEffect(() => {
    if (variant) viewItem(variant, product);
  }, [variant, product, viewItem]);

  useEffect(() => {
    const url = new URL(window.location.href);
    url.searchParams.delete("pv2");
    router.replace(url.toString(), undefined);
  }, [router]);

  return null;
}
